import { render, staticRenderFns } from "./TextMessagePreview.vue?vue&type=template&id=f45df9ea&scoped=true&"
import script from "./TextMessagePreview.vue?vue&type=script&lang=js&"
export * from "./TextMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./TextMessagePreview.vue?vue&type=style&index=0&id=f45df9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45df9ea",
  null
  
)

export default component.exports